import React from 'react';
import { render } from 'react-dom';
import Root from './Root';

export default function init() {
  const rootElement = document.getElementById('cart-ui-react-app-root');
  if (rootElement !== null) {
    // Don't render if not on the page that has the root element
    render(<Root />, rootElement);
  }
}
